/* eslint-disable @typescript-eslint/no-unused-vars */
import InputAdornment from "@mui/material/InputAdornment";
// eslint-disable-next-line import/no-duplicates
import CurrencyFormat from "react-currency-format";
import { TextField } from "@mui/material";

// eslint-disable-next-line import/no-duplicates
import React, { useState, useEffect, useContext } from "react";

import { toast } from "react-toastify";
import { useReceberBandeira } from "services/products/listarBandeiras";
import axiosProduct from "../../../../services/products";
import ToggleBtns from "../../../../components/toggleBtns";
import { Context } from "../../../../context/Context";
import * as IconsSVG from "../../../../assets/iconsSVG";
import * as Styles from "./styles";

interface Props {
  onCloseModal: () => void;
  clearFilter: boolean;
}
const FiltersContent = (props: Props) => {
  const [dataFilters, setDataFilters] = useState<any>({
    OrdenarPorRecentes: null,
  });
  const [bairros, setBairros] = useState<any>([]);
  const [radioValue, setRadioValue] = useState<string | null>("recentes");
  const { data: bandeirasData } = useReceberBandeira();
  const [quartosData, setQuartosData] = useState<any>([
    {
      value: "1",
      label: "1",
    },
    {
      value: "2",
      label: "2",
    },
    {
      value: "3",
      label: "3",
    },
    {
      value: "4",
      label: "4+",
    },
  ]);
  const { productsFilters, setProductsFilters } = useContext(Context);

  const statusData = [
    {
      value: "1",
      label: "Lançamento",
    },
    {
      value: "2",
      label: "Em obra",
    },
    {
      value: "3",
      label: "Pronto",
    },
  ];

  const tipoEmpreenditosData = [
    {
      value: "1",
      label: "Comercial",
    },
    {
      value: "2",
      label: "Residencial",
    },
    {
      value: "3",
      label: "Studio",
    },
  ];

  const vagasData = [
    {
      value: "1",
      label: "1",
    },
    {
      value: "2",
      label: "2",
    },
    {
      value: "3",
      label: "3",
    },
    {
      value: "4",
      label: "4+",
    },
  ];

  const zonasData = [
    { label: "Norte", value: 1 },
    { label: "Sul", value: 2 },
    { label: "Centro", value: 3 },
    { label: "Leste", value: 4 },
    { label: "Oeste", value: 5 },
  ];

  useEffect(() => {
    if (
      dataFilters?.Tipos &&
      dataFilters?.Tipos?.length === 1 &&
      dataFilters?.Tipos[0] === "3"
    ) {
      setQuartosData([
        {
          value: "1",
          label: "1",
        },
      ]);
    } else {
      setQuartosData([
        {
          value: "1",
          label: "1",
        },
        {
          value: "2",
          label: "2",
        },
        {
          value: "3",
          label: "3",
        },
        {
          value: "4",
          label: "4+",
        },
      ]);
    }
  }, [dataFilters?.Tipos]);

  useEffect(() => {
    requestBairros();
    if (productsFilters) {
      setDataFilters(productsFilters);
    }
  }, []);

  const handleFilters = () => {
    setProductsFilters(dataFilters);
    props.onCloseModal();
  };

  const handleCleanFilters = () => {
    const ACBtns = document.querySelectorAll(".MuiAutocomplete-clearIndicator");
    if (ACBtns) {
      ACBtns.forEach((el: any) => el.click());
    }
    setRadioValue("recentes");
    setDataFilters({
      OrdenarPorRecentes: null,
      InicioIntervaloMetragemImovel: "",
      FimIntervaloMetragemImovel: "",
      InicioIntervaloValorImovel: "",
      FimIntervaloValorImovel: "",
    });
  };

  useEffect(() => {
    if (props.clearFilter === true) {
      handleCleanFilters();
    }
  }, [props.clearFilter]);

  const requestBairros = async () => {
    try {
      const response = await axiosProduct.GetBairrosEmpreendimentos();
      const { data } = response.data;

      setBairros(
        data.map((item: { nome: string; id: string }) => {
          return {
            label: item.nome,
            value: item.id,
          };
        })
      );
    } catch (error: any) {
      toast.error(
        `${
          error?.response?.data?.notifications?.map(
            (item: any) => `${item.message}\n`
          ) || "Erro ao listar bairros."
        }`
      );
    }
  };
  return (
    <>
      <Styles.HeaderModal>
        <IconsSVG.FilterModalIcon />
        <Styles.HeaderModalTitle>Filtros</Styles.HeaderModalTitle>
        <Styles.ClearBtn onClick={handleCleanFilters}>
          Limpar campos
        </Styles.ClearBtn>
      </Styles.HeaderModal>
      <Styles.ContentModal>
        <Styles.LabelModal>Ordenar por</Styles.LabelModal>
        <Styles.RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          defaultValue="recentes"
          value={radioValue}
          name="radio-buttons-group"
          onChange={(e) => {
            setRadioValue(e.target.value);
            setDataFilters({
              ...dataFilters,
              OrdenarPorRecentes: e.target.value,
            });
          }}
        >
          <Styles.FormControlLabel
            value="recentes"
            control={<Styles.Radio />}
            label="Recentes"
          />
          <Styles.FormControlLabel
            value="antigos"
            control={<Styles.Radio />}
            label="Antigos"
          />
        </Styles.RadioGroup>
        <Styles.LabelText style={{ marginTop: 16 }}>
          Status do produto
        </Styles.LabelText>
        <ToggleBtns
          data={statusData}
          value={dataFilters?.Status}
          onChange={(newValues: any) => {
            setDataFilters({
              ...dataFilters,
              Status: newValues,
            });
          }}
        />
        <Styles.LabelText style={{ marginTop: 16 }}>Bandeira</Styles.LabelText>
        <ToggleBtns
          data={
            bandeirasData?.bandeiras?.map((bandeira: any) => ({
              label: bandeira.nome,
              value: bandeira.codigo,
            })) || []
          }
          value={dataFilters?.Bandeiras}
          onChange={(newValues: any) => {
            setDataFilters({
              ...dataFilters,
              Bandeiras: newValues,
            });
          }}
        />
        {/* <Styles.LabelText style={{ marginTop: 16 }}>
          Tipo de empreendimento
        </Styles.LabelText>
        <ToggleBtns
          data={tipoEmpreenditosData}
          value={dataFilters?.Tipos}
          onChange={(newValues: any) => {
            setDataFilters({
              ...dataFilters,
              Tipos: newValues,
            });
          }}
        /> */}
        <Styles.LabelText style={{ marginTop: 16 }}>
          Dormitórios (Quartos)
        </Styles.LabelText>
        <ToggleBtns
          data={quartosData}
          value={dataFilters?.QuantidadeDormitorios}
          onChange={(newValues: any) => {
            setDataFilters({
              ...dataFilters,
              QuantidadeDormitorios: newValues,
            });
          }}
        />
        <Styles.LabelText style={{ marginTop: 16 }}>Vagas</Styles.LabelText>
        <ToggleBtns
          data={vagasData}
          value={dataFilters?.QuantidadeVagas}
          onChange={(newValues: any) => {
            setDataFilters({
              ...dataFilters,
              QuantidadeVagas: newValues,
            });
          }}
        />
        <Styles.LabelModal style={{ marginTop: 16, marginBottom: 16 }}>
          Valor do imóvel
        </Styles.LabelModal>
        <Styles.Row style={{ alignItems: "center" }}>
          <CurrencyFormat
            customInput={Styles.TextField}
            value={dataFilters?.InicioIntervaloValorImovel}
            onValueChange={(values) =>
              setDataFilters({
                ...dataFilters,
                InicioIntervaloValorImovel: values.value,
              })
            }
            variant="outlined"
            thousandSeparator="."
            decimalSeparator=","
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">R$</InputAdornment>
              ),
            }}
          />
          <Styles.TextCenter>até</Styles.TextCenter>
          <CurrencyFormat
            customInput={Styles.TextField}
            value={dataFilters?.FimIntervaloValorImovel}
            onValueChange={(values) =>
              setDataFilters({
                ...dataFilters,
                FimIntervaloValorImovel: values.value,
              })
            }
            variant="outlined"
            thousandSeparator="."
            decimalSeparator=","
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">R$</InputAdornment>
              ),
            }}
          />
        </Styles.Row>
        <Styles.LabelModal style={{ marginTop: 16, marginBottom: 16 }}>
          Metragem
        </Styles.LabelModal>
        <Styles.Row style={{ alignItems: "center" }}>
          <Styles.TextField
            variant="outlined"
            type="number"
            value={dataFilters?.InicioIntervaloMetragemImovel}
            onChange={(e) =>
              setDataFilters({
                ...dataFilters,
                InicioIntervaloMetragemImovel: e.target.value,
              })
            }
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">m²</InputAdornment>
              ),
            }}
          />
          <Styles.TextCenter>até</Styles.TextCenter>
          <Styles.TextField
            variant="outlined"
            type="number"
            value={dataFilters?.FimIntervaloMetragemImovel}
            onChange={(e) =>
              setDataFilters({
                ...dataFilters,
                FimIntervaloMetragemImovel: e.target.value,
              })
            }
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">m²</InputAdornment>
              ),
            }}
          />
        </Styles.Row>
        <Styles.LabelText style={{ marginTop: 16 }}>Zona</Styles.LabelText>
        <Styles.Autocomplete
          multiple
          id="checkboxes-tags-demo"
          options={zonasData.map((item: any) => ({
            label: item.label,
            value: item.value,
          }))}
          size="small"
          disableCloseOnSelect
          getOptionLabel={(option: any) => option.label || ""}
          // @ts-ignore
          getOptionSelected={(option, value) => option.label === value.label}
          value={dataFilters?.Zonas}
          // @ts-ignore
          defaultValue={productsFilters?.Zonas || []}
          // @ts-ignore
          onChange={(event: any, value: any) => {
            // @ts-ignore
            setDataFilters({
              ...dataFilters,
              Zonas: value,
            });
          }}
          renderInput={(params) => (
            <TextField {...params} placeholder="" variant="outlined" />
          )}
        />
        <Styles.LabelText style={{ marginTop: 16, marginBottom: 8 }}>
          Bairro
        </Styles.LabelText>
        <Styles.Autocomplete
          // disabled={
          //   dataFilters?.Zonas?.length <= 0 || dataFilters?.Zonas === undefined
          // }
          // multiple
          id="checkboxes-tags-demo"
          options={bairros.map((item: any) => ({
            label: item.label,
            value: item.value,
          }))}
          size="small"
          disableCloseOnSelect
          getOptionLabel={(option: any) => option.label || ""}
          // @ts-ignore
          getOptionSelected={(option, value) => option.label === value.label}
          value={dataFilters?.IdBairro}
          // @ts-ignore
          defaultValue={productsFilters?.IdBairro || []}
          // @ts-ignore
          onChange={(event: any, value: any) => {
            // @ts-ignore
            setDataFilters({
              ...dataFilters,
              IdBairro: value,
            });
          }}
          renderInput={(params) => (
            <TextField {...params} placeholder="" variant="outlined" />
          )}
        />
      </Styles.ContentModal>
      <Styles.FooterModal>
        <Styles.Button onClick={handleFilters}>Aplicar filtro</Styles.Button>
      </Styles.FooterModal>
    </>
  );
};

export default FiltersContent;
